export interface AnnouncementBarConfig {
    id: string;
    enabled: boolean;
    content: string;
    backgroundColor: string;
    theme: 'dark' | 'light';
}

export const announcementBarConfig: AnnouncementBarConfig = {
    id: "new-talent-directory-2026-1",
    enabled: true,
    content: "<p>🚀  Welcome to our new experts directory. Past client? Access your old dashboard <a href=\"https://app.shopexperts.com/client/login\" target=\"_blank\">here</a>.</p>",
    backgroundColor: "#1a1a1a",
    theme: "dark"
};
